import React from "react";
import { Link } from "./PageLink";
import { CLUSTERS } from "../lib/areas";

const PinIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const AreaGrid: React.FC = () => (
  <div className="area-grid" data-testid="area-grid">
    {CLUSTERS.map((c) => (
      <Link to={c.path} key={c.slug} className="area-link" data-testid={`link-area-${c.slug}`}>
        <span className="area-link-head">
          <PinIcon />
          <h3>{c.name}</h3>
        </span>
        <h4 className="area-link-cities" data-testid={`cities-${c.slug}`}>{c.cities.join(", ")}</h4>
      </Link>
    ))}
  </div>
);

export default AreaGrid;
